module.exports = __webpack_public_path__ + "img/SEL24105G-min.4b46171a.jpg";